var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.568,
    height: 18.569,
    viewBox: "0 0 18.568 18.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(-0.003 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114550",
    "data-name": "Group 114550",
    transform: "translate(0.003 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114549",
    "data-name": "Group 114549",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365932",
    "data-name": "Path 365932",
    d: "M17.312,15.193H14.357a3.376,3.376,0,1,1,0-6.752h2.955a.422.422,0,0,0,.422-.422V6.752A1.685,1.685,0,0,0,16.18,5.078L13.755.845A1.671,1.671,0,0,0,11.463.227L3.151,5.064H1.692A1.69,1.69,0,0,0,0,6.753V16.881a1.69,1.69,0,0,0,1.689,1.688H16.045a1.69,1.69,0,0,0,1.689-1.688V15.615A.422.422,0,0,0,17.312,15.193ZM14.279,3.458l.92,1.606h-3.68ZM4.829,5.064,11.888.957a.817.817,0,0,1,.627-.084.828.828,0,0,1,.507.392v0L6.5,5.064Z",
    transform: "translate(-0.003 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365933",
    "data-name": "Path 365933",
    d: "M304.115,234.674h-2.932a2.513,2.513,0,1,0,0,5.026h2.932a1.258,1.258,0,0,0,1.257-1.257V235.93A1.258,1.258,0,0,0,304.115,234.674Zm-2.932,3.351a.838.838,0,1,1,.838-.838A.839.839,0,0,1,301.183,238.025Z",
    transform: "translate(-286.803 -225.363)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ee10d9fb614d79af62958cb557e76c53.svg";
export { ForwardRef as ReactComponent };